// using bootstrap for the navbar, making it a component so it can be used on other pages
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";


export function Navbar() {
    return (
        <nav class="navbar navbar-expand-lg">
            <div class="container-fluid">
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <li class="nav-item">
                        <HashLink to={"/#intro"} className="navlink">Home</HashLink>
                    </li>
                    <li class="nav-item">
                        <HashLink to={"/#about"} className="navlink">About</HashLink>
                    </li>
                    <li class="nav-item">
                        <HashLink to={"/#contact"} className="navlink">Contact</HashLink>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="/" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            Projects
                        </a>
                        <ul class="dropdown-menu">
                            <li class="projthumbnail"><Link to={"/Web-Projects"} className="navlink">Web Development</Link></li>
                            <li class="projthumbnail"><Link to={"/Game-Projects"} className="navlink">Game Development</Link></li>
                            <li class="projthumbnail"><Link to={"/UIUX-Projects"} className="navlink">UI/UX</Link></li>
                            <li class="projthumbnail"><Link to={"/DirectX11-Projects"} className="navlink">DirectX11</Link></li>
                        </ul>
                    </li>
                </ul>
                </div>
            </div>
        </nav>
    );
}
